import './App.css';
import { Tldraw, track, useEditor, TLUiOverrides, toolbarItem, GeoShapeGeoStyle, Editor, AssetRecordType, useCallback, DefaultColorStyle, forwardRef, createShapeId} from '@tldraw/tldraw'
import '@tldraw/tldraw/tldraw.css'
import { useEffect, useState, useRef, Component, createRef, componentDidMount} from 'react'
import './custom-ui.css'

import activePointerIcon from "./tool_icons/active/pointer.svg"
import activeEraserIcon from "./tool_icons/active/eraser.svg"
import activeArrowIcon from "./tool_icons/active/arrow.svg"
import activeRectangleIcon from "./tool_icons/active/rectangle.svg"
import activeStarIcon from "./tool_icons/active/star.svg"
import inactivePointerIcon from "./tool_icons/inactive/pointer.svg"
import inactiveEraserIcon from "./tool_icons/inactive/eraser.svg"
import inactiveArrowIcon from "./tool_icons/inactive/arrow.svg"
import inactiveRectangleIcon from "./tool_icons/inactive/rectangle.svg"
import inactiveStarIcon from "./tool_icons/inactive/star.svg"

import parkImage from './backgrounds/park.png'
import drivewayImage from './backgrounds/driveway.jpeg'
import livingRoomTable from './backgrounds/living_room_table.jpeg'
import parkTable from './backgrounds/park_table.png'
import kitchenTable from './backgrounds/kitchen_table.jpeg'

const imageWidth = 500;
const imageHeight = 500;

// Default Backgrounds
const default_background_data = {
    "park": {
        "default_instruction": "Add a dog {'x': 0.2, 'y': 0.3, 'width': 0.5, 'height': 0.5}",
		"default_layout": {}, 
        "background_image": parkImage
    },
	"driveway": {
		"default_instruction": "Add a dog {'x': 0.2, 'y': 0.3, 'width': 0.5, 'height': 0.5}",
		"default_layout": {}, 
		"background_image": drivewayImage
	},
	"living_room_table": {
		"default_instruction": "Add a dog {'x': 0.2, 'y': 0.3, 'width': 0.5, 'height': 0.5}",
		"default_layout": {}, 
		"background_image": livingRoomTable
	},
	"park_table": {
		"default_instruction": "Add a dog {'x': 0.2, 'y': 0.3, 'width': 0.5, 'height': 0.5}",
		"default_layout": {}, 
		"background_image": parkTable
	},
	"kitchen_table": {
		"default_instruction": "Add a dog {'x': 0.2, 'y': 0.3, 'width': 0.5, 'height': 0.5}",
		"default_layout": {}, 
		"background_image": kitchenTable
	}
}

function sendRequestForImage() {
	fetch('http://127.0.0.1:5000/image')
		.then(response => response.blob())
		.then(blob => {
			// Create a URL for the blob object
			const imageUrl = URL.createObjectURL(blob);

			// Create an image element and set its src to the blob URL
			const image = new Image();
			image.src = imageUrl;
			document.body.appendChild(image); // Append the image to the DOM
		})
		.catch(error => console.error('Error:', error));
}

function getCursorPosition(editableDiv) {
    var caretPos = 0, containerEl = null, sel, range;
    if (window.getSelection) {
        sel = window.getSelection();
        if (sel.rangeCount) {
            range = sel.getRangeAt(0);
            if (range.commonAncestorContainer.parentNode == editableDiv) {
                caretPos = range.endOffset;
            }
        }
    } else if (document.selection && document.selection.createRange) {
        // Support for IE
        range = document.selection.createRange();
        if (range.parentElement() == editableDiv) {
            var tempEl = document.createElement("span");
            editableDiv.insertBefore(tempEl, editableDiv.firstChild);
            var tempRange = range.duplicate();
            tempRange.moveToElementText(tempEl);
            tempRange.setEndPoint("EndToEnd", range);
            caretPos = tempRange.text.length;
        }
    }
    return caretPos;
}


// [2]
const Toolbar = track((props) => {
	const editor = useEditor()
	
	// Make sure the camera can't be moved
	const [stateObject, setState] = useState({
		currentTool: 'select',
	});
	const currentTool = stateObject.currentTool;

	const pointerIcon = currentTool === 'select' ? activePointerIcon : inactivePointerIcon;
	const eraserIcon = currentTool === 'eraser' ? activeEraserIcon : inactiveEraserIcon;
	const arrowIcon = currentTool === 'arrow' ? activeArrowIcon : inactiveArrowIcon;
	const rectangleIcon = currentTool === 'rectangle' ? activeRectangleIcon : inactiveRectangleIcon;
	const starIcon = currentTool === 'star' ? activeStarIcon : inactiveStarIcon;

	return (
		<div className="custom-toolbar">
			<img 
				className="custom-tool" 
				id="tool-pointer" 
				src={pointerIcon} 
				alt="pointer"
				draggable="false"
				onClick={() => {
					editor.setCurrentTool('select');
					setState(
						prevState => {
							return {currentTool: 'select'};
						}
					)
				}}
			/>
			<img 
				className="custom-tool" 
				id="tool-eraser" 
				src={eraserIcon} 
				alt="eraser"
				draggable="false"
				onClick={() => {
					editor.setCurrentTool('eraser')
					setState(
						prevState => {
							return {currentTool: 'eraser'};
						}
					)
				}}
			/>
			<img
				onClick={() => {
					editor.updateInstanceState(
						{
							stylesForNextShape: {
								...editor.getInstanceState().stylesForNextShape,
								[GeoShapeGeoStyle.id]: "star",
							},
						},
						{ ephemeral: true }
					)
					// update the current color
					editor.setStyleForNextShapes(
						DefaultColorStyle, 
						props.currentColor
					)
					editor.setCurrentTool('geo')
					setState(
						prevState => {
							return {currentTool: 'star'};
						}
					)
				}}
				className="custom-tool" 
				id="tool-star" 
				src={starIcon} 
				alt="star"
				draggable="false"
			/>
			<img 
				className="custom-tool" 
				id="tool-rectangle" 
				src={rectangleIcon} 
				alt="rectangle"
				draggable="false"
				onClick={() => {
					editor.updateInstanceState(
						{
							stylesForNextShape: {
								...editor.getInstanceState().stylesForNextShape,
								[GeoShapeGeoStyle.id]: "rectangle",
							},
						},
						{ ephemeral: true }
					)
					editor.setStyleForNextShapes(
						DefaultColorStyle, 
						props.currentColor
					)
					editor.setCurrentTool('geo')
					setState(
						prevState => {
							return {currentTool: 'rectangle'};
						}
					)
				}}
			/>
			{/* <img 
				className="custom-tool" 
				id="tool-arrow" 
				src={arrowIcon} 
				alt="arrow"
				draggable="false"
				onClick={() => {
					editor.setCurrentTool('arrow')
					setState(
						prevState => {
							return {currentTool: 'arrow'};
						}
					)
					editor.setStyleForNextShapes(
						DefaultColorStyle, 
						props.currentColor
					)
				}}
			/>	 */}
		</div>
	)
});

const colorPaletteToHex = {
	"blue": "#2f80ed",
	// "yellow": "#ffc078",
	// "green": "#0b9268",
}

function Arrow(props) {
	return <>
		<span>&nbsp;</span>
		<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M24 18.4667L24 6.00001M24 6.00001L11.5333 6.00001M24 6.00001L7.00002 23" stroke={props.color} stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
		</svg>
		<span>&nbsp;</span>
	</>
}

function Rectangle(props) {
	return <>
		<span>&nbsp;</span>
		<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M5 3H25C26.1046 3 27 3.89543 27 5V25C27 26.1046 26.1046 27 25 27H5C3.89543 27 3 26.1046 3 25V5C3 3.89543 3.89543 3 5 3Z" stroke={props.color} stroke-width="3"/>
		</svg>
		<span>&nbsp;</span>
	</>
}

function Star(props) {
	return <>
		<span>&nbsp;</span>
		<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M15 3.53101L19.1119 9.19117C19.3602 9.53294 19.7103 9.78732 20.1121 9.91783L26.7658 12.0794L22.6533 17.7391C22.405 18.0809 22.2713 18.4925 22.2713 18.9149L22.2717 25.911L15.6181 23.7487C15.2164 23.6181 14.7836 23.6181 14.3819 23.7487L7.72831 25.911L7.72868 18.9149C7.7287 18.4925 7.59497 18.0809 7.34665 17.7391L3.23417 12.0794L9.88794 9.91783C10.2897 9.78732 10.6398 9.53294 10.8881 9.19117L15 3.53101Z" stroke={props.color} stroke-width="3"/>
		</svg>
		<span>&nbsp;</span>
	</>
}

function getShapeType(shape) {
	if (shape.type === "arrow") {
		return "arrow";
	} else if (shape.type === "geo") {
		return shape.props.geo;
	} else {
		return "other"
	}
}

function convertInputBoxArrayToInstruction(inputBoxArray, shapes) {
	// Converts the input box array to a format that can be understood by the backend
	// I.e. "Add a dog {'x': 0.2, 'y': 0.3, 'width': 0.5, 'height': 0.5}"
}

// Implements a vertical bar where different backgrounds can be selected. 
const Backgrounds = track((props) => {
	const editor = useEditor();
	const updateCurrentBackground = props.updateCurrentBackground;
	const currentBackground = props.currentBackground;

	return (
		<div className="background-container"> 
			{
				Object.entries(default_background_data).map(([backgroundKey, backgroundData]) => {
					return <img
						onClick={() => {
							if (currentBackground == backgroundKey) {
								return;
							} else {
								// Remove shapes from the editor
								editor.updateShapes([])
								// Reset the background name
								updateCurrentBackground(backgroundKey);
								console.log(currentBackground)
							}
						}}
						draggable="false"
						className={"background-bar-item" + (props.currentBackground == backgroundKey ? " active" : " inactive")}
						src={backgroundData.background_image}
					>
					</img>
				})
			}
		</div>
	)
})

// Input box
const InputBox = function(props) {
	const editor = useEditor()
	const inputBoxRef = useRef(null);
	const containerRef = props.containerRef;
	const buttonRef = useRef(null);
	const updateColorIndex = props.updateColorIndex;
	const [state, updateState] = useState({"shapes": {}, "inputBoxArray": []});
	// Take the given string and replace [shape] with an svg for the correct shape
	// Split the string into an array of strings and shapes
	// Initialize the image based on the current background
	const defaultBackground = default_background_data[props.currentBackground];
	// const assetId = AssetRecordType.createId()
	// editor.createAssets([
	// 	{
	// 		id: AssetRecordType.createId(),
	// 		type: 'image',
	// 		typeName: 'asset',
	// 		props: {
	// 			name: 'background',
	// 			src: defaultBackground.background_image,
	// 			w: 500,
	// 			h: 500,
	// 			mimeType: 'image/png',
	// 			isAnimated: false,
	// 		},
	// 		meta: {},
	// 	},
	// ])
	// //[3]
	// const imageWidth = 500;
	// const imageHeight = 500;
	// editor.createShape({
	// 	type: 'image',
	// 	// Let's center the image in the editor
	// 	x: (500 - imageWidth) / 2,
	// 	y: (700 - imageHeight) / 2,
	// 	isLocked: true,
	// 	props: {
	// 		assetId,
	// 		w: imageWidth,
	// 		h: imageHeight,
	// 	},
	// })

	useEffect(() => {
		const containerElement = containerRef.current;
		containerElement.editor = editor;

		function populateDefaultInstruction(instruction) {
			// Converts the given instruction from a format like "move {'x': 0.2, 'y': 0.3, 'width': 0.5, 'height': 0.5} to the right"
			// to the input box state format 
			let inputBoxArray = [];
			let shapes = {};
			let shapeBuffer = "";
			let readingShape = false;

			for (let char of instruction) {
				if (char === "{") {
					readingShape = true;
					shapeBuffer = "";
				} else if (char === "}") {
					// Now detect if the shape is a point or rectangle
					const shape = JSON.parse("{" + shapeBuffer + "}");
					if (shape["width"] === undefined) {
						// Add a star to the editor window
						const newShape = {
							id: createShapeId(),
							type: 'geo',
							x: shape["x"] * imageWidth,
							y: shape["y"] * imageHeight,
							isLocked: false,
							props: {
								w: imageWidth * 0.05,
								h: imageHeight * 0.05,
								geo: "star",
							},
						}
						editor.createShapes([newShape])
						// Add a star to the shapes dictionary
						shapes[newShape.id] = newShape;
						// Add a shape to the input box array
						inputBoxArray.push("star");
					} else {
						// Add a rectangle
						const newShape = {
							id: createShapeId(),
							type: 'geo',
							x: shape["x"] * imageWidth,
							y: shape["y"] * imageHeight,
							isLocked: false,
							props: {
								w: shape["width"] * imageWidth,
								h: shape["height"] * imageHeight,
								geo: "rectangle",
							},
						}
						editor.createShapes([newShape])
						// Add a rectangle to the shapes dictionary
						shapes[newShape.id] = newShape;
						// Add a rectangle to the input box array
						inputBoxArray.push("rectangle");
					}
					// Empty the shape buffer
					shapeBuffer = "";
					readingShape = false;
				} else {
					// Add the character to the input box array
					inputBoxArray.push(char);
				}
			}
			// Set the state of the input box
			updateState(
				prevState => {
					return {
						"shapes": shapes,
						"inputBoxArray": inputBoxArray,
					}
				}
			);
		}

		function mouseClickEventHandler(event){
			event.stopPropagation();
			// Set a time out to then check if there is a new shape.
			// NOTE: The reason this is necessary is because there are duplicate
			// add events in the tldraw event listener
			setTimeout(() => {
				// Detect a change in the editor state
				updateState(
					prevState => {
						// Unpack current state
						const prevShapes = prevState.shapes;
						const prevInputBoxArray = prevState.inputBoxArray;
						// Get the shapes from the editor
						const editorAtoms = editor.store.atoms.current;
						const editorShapeKeys = Object.keys(editorAtoms).filter(atomKey => atomKey.includes("shape"));
						const editorShapes = editorShapeKeys.map(shapeKey => editorAtoms[shapeKey].current);
						// Detect the new shape (assume only one)
						const newShapes = editorShapes.filter(shape => !Object.keys(prevShapes).includes(shape.id));
						// Make sure it is a rectangle, arrow, or star
						for (const shape of newShapes) {
							// Make sure the shape type is valid 
							const shapeType = getShapeType(shape);
							if (shapeType === "other") {
								continue;
							}
							// Add the shape to the input box array
							prevInputBoxArray.push(shape);
							// Add the shape to the shapes object
							prevShapes[shape.id] = shape;
						}
						// Return the new state
						return {
							"shapes": prevShapes,
							"inputBoxArray": prevInputBoxArray,
						}
					}
				)
			}, 20)
		}

		function inputBoxKeyDownHandler(event) {
			event.preventDefault();
			// // Take the last character in the div and add it to the input box array
			const inputCharacter = event.key;
			updateState(
				prevState => {
					return {
						...prevState,
						"inputBoxArray": [...prevState.inputBoxArray, inputCharacter],
					}
				}
			);
		}

		function generateImage(){
			// Sends content of input box in post request
			//[2]
			const assetId = AssetRecordType.createId()

			const jsonData = {
				"shapes": state['shapes'],
				"inputBoxArray": state['inputBoxArray']
			}

			// Reset the editor state
			const editorAtoms = editor.store.atoms.current;
			const editorShapeKeys = Object.keys(editorAtoms).filter(atomKey => atomKey.includes("shape"));
			for (const shapeKey of editorShapeKeys) {
				editor.deleteShape(shapeKey);
			}
			// Reset the component state
			updateState({"shapes": {}, "inputBoxArray": []});
			// Reset the color index
			fetch('http://127.0.0.1:5000/generate_image', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify(jsonData)
				})
				.then(response => response.json())
				.then(data => {
					const base64String = data.image
					const imageString = 'data:image/png;base64,' + base64String;
					//[2]
					editor.createAssets([
						{
							id: assetId,
							type: 'image',
							typeName: 'asset',
							props: {
								name: 'logo192.png',
								src: imageString, // You could also use a base64 encoded string here
								w: imageWidth,
								h: imageHeight,
								mimeType: 'image/png',
								isAnimated: false,
							},
							meta: {},
						},
					])
					//[3]
					editor.createShape({
						type: 'image',
						// Let's center the image in the editor
						x: (500 - imageWidth) / 2,
						y: (700 - imageHeight) / 2,
						isLocked: true,
						props: {
							assetId,
							w: imageWidth,
							h: imageHeight,
						},
					})
				})
				.catch(error => console.error('Error:', error));	
				// empty the input box
		}
		containerElement.addEventListener("mouseup", mouseClickEventHandler);
		containerElement.removeEventListener("keydown", inputBoxKeyDownHandler);
		buttonRef.current.addEventListener("click", generateImage);
		// Run initialization for input box
		populateDefaultInstruction(defaultBackground.default_instruction);
	}, []);

	return (
		<div className="input-box-container">
			<div 
				className='input-box'
				type="text"
				data-placeholder="Write a prompt"
				contentEditable="true"
				ref={inputBoxRef}
			>
				{
					state["inputBoxArray"].map((element, index) => {
						const shapeType = getShapeType(element);
						if (shapeType === "star") {
							return <Star color={colorPaletteToHex[element.props.color]} key={index}/>
						} else if (shapeType === "rectangle") {
							return <Rectangle color={colorPaletteToHex[element.props.color]} key={index}/>
						} else if (shapeType === "arrow") {
							return <Arrow color={colorPaletteToHex[element.props.color]} key={index}/>
						} else {
							return <span key={index}>{element}</span>
						}
					})
				}
			</div>
			<div 
				className="input-box-button"
				ref={buttonRef}
			>
				Run
			</div>
		</div>
	);
}

class App extends Component {

  constructor(props) {
	super(props);
	// Bind the function to the class
	this.updateColorIndex = this.updateColorIndex.bind(this);
	this.updateCurrentBackground = this.updateCurrentBackground.bind(this);
	// Create a reference to input box
	this.editorWrapperRef = createRef();
	this.colorPalette = [
		"blue",
		"yellow",
		"green"
	];
	// Setup state that stores the information for the input box
	this.state = {
		currentColorIndex: 0,
		currentBackground: "park",
	};
  }

  updateColorIndex() {
	this.setState(
		prevState => {
			return {currentColorIndex: (prevState.currentColorIndex + 1) % this.colorPalette.length};
		}
	);
  }

  updateCurrentBackground(backgroundKey) {
	// If the new background is different from the current one then
	// Add the new background image to the editor, and add the default input box. 
	this.setState(
		prevState => {
			return {currentBackground: backgroundKey, ...prevState};
		}
	);
  }

  render() {
	return (
		<div className="App">
			<header className="App-header">
				<div 
					className="tldraw-editor"
					ref={this.editorWrapperRef}
				>
					<Tldraw hideUi>
						<div className="custom-layout">
							<div className="left-container">
								<Backgrounds
									currentBackground={this.state.currentBackground}
									updateCurrentBackground={this.updateCurrentBackground}
								/>
							</div>
							<div className="right-container">
								<Toolbar
									currentColor={this.colorPalette[this.state.currentColorIndex]}
								/>
								<InputBox
									updateColorIndex={this.updateColorIndex}
									containerRef={this.editorWrapperRef}
									currentBackground={this.state.currentBackground}
								/>
							</div>
						</div>
					</Tldraw>
				</div>
			</header>
		</div>
	);
  }
}

export default App;